const departments = [
    "Aeronautical Engineering",
    "Aerospace Engineering",
    "Agricultural & Irrigation Engineering",
    "Aircraft Maintenance Engineering",
    "Animation",
    "Apparel technology",
    "Applied electronics",
    "Applied Mathematics",
    "Architecture",
    "Automobile Engineering",
    "Avionics",
    "Bio Informatics",
    "Bio Medical Engineering",
    "Biotechnology",
    "Ceramic Technology",
    "Charted Accountancy",
    "Chemical Engineering",
    "Chemistry",
    "Civil Engineering",
    "Communication Systems",
    "Computer Science & Engineering",
    "Cryogenic Engineering",
    "Elecrical Engineering",
    "Electrical & Electronics Engineering",
    "Electronic media",
    "Electronics & Communication Engineering",
    "Electronics & Instrumentation",
    "Embedded Systems",
    "Energy Engineering",
    "Engineering Design",
    "Engineering Physics",
    "English Literature",
    "Finance",
    "Fluid Mechanics",
    "Food Technology",
    "Geo Informatics",
    "Harbour Engineering",
    "High Voltage Engineering",
    "Hospitality Administration",
    "HR",
    "Humanities & Social Sciences",
    "Industrial Engineering",
    "Information & Communications Technology",
    "Information Technology",
    "Internal Combustion Engineering",
    "Logistics",
    "M.Sc. CS-IT",
    "M.Sc. E-Media",
    "Manufacturing Engineering",
    "Marine Engineering",
    "Marketing",
    "Material Science",
    "Mathematics",
    "Mechanical Engineering",
    "Mechatronics",
    "Media Sciences",
    "Metallurgy",
    "Mining Engineering",
    "Nano Science and Technology",
    "Other",
    "Photonics",
    "Physics",
    "Printing Technology",
    "Production Engineering",
    "Remote Sensing",
    "Software Engineering",
    "Systems Engineering & Operations Research",
    "Technology Managment",
    "Telecommunication Engineering",
    "Textile Technology",
    "Theoretical Computer Science",
    "Thermal",
    "Transportation Engineering",
    "VLSI Design",
    "Other"
 ];

export default departments;